export type MapleMarketInstalledRecord = {
  sku: string;
  rootPath: string;
  version: string;
  productName: string;
  installedAt: string;
  lastPlayedAt: string | null;
};

const STORAGE_KEY = 'maple-market-installed-products';

function canUseStorage() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

export function readInstalledMapleMarketProducts(): Record<string, MapleMarketInstalledRecord> {
  if (!canUseStorage()) {
    return {};
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }

    const parsed = JSON.parse(raw) as Record<string, MapleMarketInstalledRecord>;
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeInstalledMapleMarketProducts(records: Record<string, MapleMarketInstalledRecord>) {
  if (!canUseStorage()) {
    return;
  }

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(records));
  window.dispatchEvent(new CustomEvent('maple-market:library-refresh'));
}

export function saveInstalledMapleMarketProduct(record: MapleMarketInstalledRecord) {
  const current = readInstalledMapleMarketProducts();
  writeInstalledMapleMarketProducts({
    ...current,
    [record.sku]: record,
  });
}

export function markPlayedMapleMarketProduct(sku: string) {
  const current = readInstalledMapleMarketProducts();
  const existing = current[sku];
  if (!existing) {
    return;
  }

  writeInstalledMapleMarketProducts({
    ...current,
    [sku]: {
      ...existing,
      lastPlayedAt: new Date().toISOString(),
    },
  });
}
